import { getSelectedWarehouse } from "@crescentParts/Services/SelectedWarehouseInventoryService";
import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const PopulateApiParameterWithSelectedWarehouse: HandlerType = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;

    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
    };

    props.apiParameter.expand = [];

    if (cartSettings.showTaxAndShipping || pageType !== "CartPage") {
        props.apiParameter.expand.push("shipping");
    }

    if (!getSession(props.getState()).rememberMe) {
        props.apiParameter.expand.push("validation");
    }

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "carriers",
            "paymentOptions",
            "costCodes",
        ];

        if (pageType === "CartPage") {
            props.apiParameter.expand.push("hiddenproducts");
        }

        if (cartSettings.showTaxAndShipping || pageType !== "CartPage") {
            props.apiParameter.expand.push("tax");
        }
    }

    if (props.parameter.getCartLines) {
        props.apiParameter.expand?.push("cartLines");
    }

    if (props.parameter.getCostCodes) {
        props.apiParameter.expand?.push("costCodes");
    }

    const selectedWarehouse = getSelectedWarehouse(props.getState());
    if (selectedWarehouse) {
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters ?? {}),
            selectedWarehouse,
        };
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterWithSelectedWarehouse);
